export const AxisBottom = ( {x, innerHeight } ) => (
  x.domain().map(tickValue => (
    <text
      className="tick-label"
      transform={`translate(${x(tickValue)+x.bandwidth()/2},${innerHeight+5}) rotate(-30)`}
      key={tickValue}
      style={{textAnchor: 'end'}} 
      dy=".71em"
    >{tickValue}</text>
  ))
);

